module.exports = __webpack_public_path__ + "img/faq-icon.4323dd91.svg";